import { useState } from "react";
import { useSettings } from "../hooks/useSettings";
import { API_BASE_URL } from "../config/api";
import "../styles/LoginForm.css";

export default function LoginForm({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { settings } = useSettings();
  const background = settings?.desktopBackgroundPath;
  const bgPath = background ? `${API_BASE_URL}/${background}` : null;

  return (
    <div
      className="login-container"
      style={{
        backgroundImage: bgPath ? `url(${bgPath})` : "linear-gradient(135deg, #1e1e2c 0%, #2a2a4a 100%)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="login-box">
        <h1 className="login-title">LOGIN</h1>
        <div className="login-input-group">
          <input
            type="email"
            className="login-input"
            placeholder="E-MAIL"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="login-input-group">
          <input
            type="password"
            className="login-input"
            placeholder="PASSWORD"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button
          className="login-button"
          onClick={() => onLogin(email, password)}
        >
          ACCEDER
        </button>
      </div>
    </div>
  );
}
